const orbGradientAnimation = {
    
        v: "5.7.8",
        fr: 30,
        ip: 0,
        op: 297,
        w: 1000,
        h: 1000,
        nm: "Pre-comp 1",
        ddd: 1,
        assets: [],
        layers: [
          {
            ddd: 1,
            ind: 1,
            ty: 3,
            nm: "Null 1",
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 0,
                ix: 11
              },
              rx: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0.167
                      ]
                    },
                    t: 0,
                    s: [
                      116
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.832
                      ],
                      y: [
                        -0.065
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 149,
                    s: [
                      0
                    ]
                  },
                  {
                    t: 468,
                    s: [
                      -100
                    ]
                  }
                ],
                ix: 8
              },
              ry: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 149,
                    s: [
                      -0.038
                    ]
                  },
                  {
                    t: 366,
                    s: [
                      71.962
                    ]
                  }
                ],
                ix: 9
              },
              rz: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.623
                      ],
                      y: [
                        0.81
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0.167
                      ]
                    },
                    t: -115,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.831
                      ],
                      y: [
                        0.596
                      ]
                    },
                    o: {
                      x: [
                        0.499
                      ],
                      y: [
                        0.218
                      ]
                    },
                    t: 149,
                    s: [
                      -80
                    ]
                  },
                  {
                    t: 300,
                    s: [
                      -132.81
                    ]
                  }
                ],
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  500,
                  500,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                  100
                ],
                ix: 6
              }
            },
            ao: 0,
            ip: 0,
            op: 300,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 2,
            ty: 4,
            nm: "Shape Layer 22",
            parent: 3,
            td: 1,
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 50,
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: 0,
                ix: 9
              },
              rz: {
                a: 0,
                k: 15,
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  101.266,
                  101.266,
                  101.266
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "gf",
                    o: {
                      a: 0,
                      k: 100,
                      ix: 10
                    },
                    r: 1,
                    bm: 0,
                    g: {
                      p: 2,
                      k: {
                        a: 0,
                        k: [
                          0,
                          1,
                          1,
                          1,
                          1,
                          0.0784,
                          0.1686,
                          0.0588
                        ],
                        ix: 9
                      }
                    },
                    s: {
                      a: 0,
                      k: [
                        -512.975,
                        2.5
                      ],
                      ix: 5
                    },
                    e: {
                      a: 0,
                      k: [
                        549.589,
                        -14.873
                      ],
                      ix: 6
                    },
                    t: 1,
                    nm: "Gradient Fill 1",
                    mn: "ADBE Vector Graphic - G-Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 3,
            ty: 4,
            nm: "Shape Layer 21",
            parent: 1,
            tt: 3,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.667
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 55,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 77,
                    s: [
                      50
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 261,
                    s: [
                      50
                    ]
                  },
                  {
                    t: 295,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: -3,
                ix: 9
              },
              rz: {
                a: 0,
                k: 379.5,
                ix: 10
              },
              or: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.001
                    },
                    t: 33,
                    s: [
                      320,
                      0,
                      202
                    ],
                    to: [
                      202,
                      0,
                      0
                    ],
                    ti: [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    t: 135,
                    s: [
                      0,
                      0,
                      202
                    ]
                  }
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                        0,
                        0
                      ],
                      y: [
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333,
                        0.333,
                        0.333
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 40,
                    s: [
                      15.641,
                      15.641,
                      15.641
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833,
                        0.833,
                        0.833
                      ],
                      y: [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1,
                        1,
                        1
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 143,
                    s: [
                      79,
                      79,
                      79
                    ]
                  },
                  {
                    t: 322,
                    s: [
                      0,
                      0,
                      0
                    ]
                  }
                ],
                ix: 6
              }
            },
            ao: 0,
            ef: [
              {
                ty: 20,
                nm: "Tint",
                np: 6,
                mn: "ADBE Tint",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "Map Black To",
                    mn: "ADBE Tint-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [
                        0.9294,
                        0.3137,
                        0.6196,
                        1
                      ],
                      ix: 1
                    }
                  },
                  {
                    ty: 2,
                    nm: "Map White To",
                    mn: "ADBE Tint-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: [
                        0.298,
                        0.3451,
                        0.3882,
                        1
                      ],
                      ix: 2
                    }
                  },
                  {
                    ty: 0,
                    nm: "Amount to Tint",
                    mn: "ADBE Tint-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: 100,
                      ix: 3
                    }
                  },
                  {
                    ty: 6,
                    nm: "",
                    mn: "ADBE Tint-0004",
                    ix: 4,
                    v: 0
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 2,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      1,
                      0.0784,
                      0.1686,
                      0.0588
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -394,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    365,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: "Gradient Fill 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 3
          },
          {
            ddd: 1,
            ind: 4,
            ty: 4,
            nm: "Shape Layer 20",
            parent: 5,
            td: 1,
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 50,
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: 0,
                ix: 9
              },
              rz: {
                a: 0,
                k: 15,
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  101.266,
                  101.266,
                  101.266
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "gf",
                    o: {
                      a: 0,
                      k: 100,
                      ix: 10
                    },
                    r: 1,
                    bm: 0,
                    g: {
                      p: 2,
                      k: {
                        a: 0,
                        k: [
                          0,
                          1,
                          1,
                          1,
                          1,
                          0.0784,
                          0.1686,
                          0.0588
                        ],
                        ix: 9
                      }
                    },
                    s: {
                      a: 0,
                      k: [
                        -512.975,
                        2.5
                      ],
                      ix: 5
                    },
                    e: {
                      a: 0,
                      k: [
                        549.589,
                        -14.873
                      ],
                      ix: 6
                    },
                    t: 1,
                    nm: "Gradient Fill 1",
                    mn: "ADBE Vector Graphic - G-Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 5,
            ty: 4,
            nm: "Shape Layer 19",
            parent: 1,
            tt: 3,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.667
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 46,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 68,
                    s: [
                      50
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 254,
                    s: [
                      50
                    ]
                  },
                  {
                    t: 288,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: -24,
                ix: 9
              },
              rz: {
                a: 0,
                k: 305,
                ix: 10
              },
              or: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.001
                    },
                    t: 26,
                    s: [
                      320,
                      0,
                      202
                    ],
                    to: [
                      202,
                      0,
                      0
                    ],
                    ti: [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    t: 131,
                    s: [
                      0,
                      0,
                      202
                    ]
                  }
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                        0,
                        0
                      ],
                      y: [
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333,
                        0.333,
                        0.333
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 31,
                    s: [
                      15.641,
                      15.641,
                      15.641
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833,
                        0.833,
                        0.833
                      ],
                      y: [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1,
                        1,
                        1
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 143,
                    s: [
                      79,
                      79,
                      79
                    ]
                  },
                  {
                    t: 316.6416015625,
                    s: [
                      0,
                      0,
                      0
                    ]
                  }
                ],
                ix: 6
              }
            },
            ao: 0,
            ef: [
              {
                ty: 20,
                nm: "Tint",
                np: 6,
                mn: "ADBE Tint",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "Map Black To",
                    mn: "ADBE Tint-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [
                        0.9294,
                        0.3137,
                        0.6196,
                        1
                      ],
                      ix: 1
                    }
                  },
                  {
                    ty: 2,
                    nm: "Map White To",
                    mn: "ADBE Tint-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: [
                        0.298,
                        0.3451,
                        0.3882,
                        1
                      ],
                      ix: 2
                    }
                  },
                  {
                    ty: 0,
                    nm: "Amount to Tint",
                    mn: "ADBE Tint-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: 100,
                      ix: 3
                    }
                  },
                  {
                    ty: 6,
                    nm: "",
                    mn: "ADBE Tint-0004",
                    ix: 4,
                    v: 0
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 2,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      1,
                      0.0784,
                      0.1686,
                      0.0588
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -394,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    365,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: "Gradient Fill 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 3
          },
          {
            ddd: 1,
            ind: 6,
            ty: 4,
            nm: "Shape Layer 18",
            parent: 7,
            td: 1,
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 50,
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: 0,
                ix: 9
              },
              rz: {
                a: 0,
                k: 0,
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  101.266,
                  101.266,
                  101.266
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "gf",
                    o: {
                      a: 0,
                      k: 100,
                      ix: 10
                    },
                    r: 1,
                    bm: 0,
                    g: {
                      p: 2,
                      k: {
                        a: 0,
                        k: [
                          0,
                          1,
                          1,
                          1,
                          1,
                          0.0784,
                          0.1686,
                          0.0588
                        ],
                        ix: 9
                      }
                    },
                    s: {
                      a: 0,
                      k: [
                        -512.975,
                        2.5
                      ],
                      ix: 5
                    },
                    e: {
                      a: 0,
                      k: [
                        549.589,
                        -14.873
                      ],
                      ix: 6
                    },
                    t: 1,
                    nm: "Gradient Fill 1",
                    mn: "ADBE Vector Graphic - G-Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 7,
            ty: 4,
            nm: "Shape Layer 17",
            parent: 1,
            tt: 3,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.667
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 40,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 62,
                    s: [
                      50
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 248,
                    s: [
                      50
                    ]
                  },
                  {
                    t: 282,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: -38,
                ix: 9
              },
              rz: {
                a: 0,
                k: 290,
                ix: 10
              },
              or: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.001
                    },
                    t: 21,
                    s: [
                      320,
                      0,
                      223
                    ],
                    to: [
                      223,
                      0,
                      0
                    ],
                    ti: [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    t: 125,
                    s: [
                      0,
                      0,
                      223
                    ]
                  }
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                        0,
                        0
                      ],
                      y: [
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333,
                        0.333,
                        0.333
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 23,
                    s: [
                      15.641,
                      15.641,
                      15.641
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833,
                        0.833,
                        0.833
                      ],
                      y: [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1,
                        1,
                        1
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 143,
                    s: [
                      79,
                      79,
                      79
                    ]
                  },
                  {
                    t: 307.6865234375,
                    s: [
                      0,
                      0,
                      0
                    ]
                  }
                ],
                ix: 6
              }
            },
            ao: 0,
            ef: [
              {
                ty: 20,
                nm: "Tint",
                np: 6,
                mn: "ADBE Tint",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "Map Black To",
                    mn: "ADBE Tint-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [
                        0.9294,
                        0.3137,
                        0.6196,
                        1
                      ],
                      ix: 1
                    }
                  },
                  {
                    ty: 2,
                    nm: "Map White To",
                    mn: "ADBE Tint-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: [
                        0.298,
                        0.3451,
                        0.3882,
                        1
                      ],
                      ix: 2
                    }
                  },
                  {
                    ty: 0,
                    nm: "Amount to Tint",
                    mn: "ADBE Tint-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: 100,
                      ix: 3
                    }
                  },
                  {
                    ty: 6,
                    nm: "",
                    mn: "ADBE Tint-0004",
                    ix: 4,
                    v: 0
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 2,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      1,
                      0.0784,
                      0.1686,
                      0.0588
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -394,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    365,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: "Gradient Fill 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 3
          },
          {
            ddd: 1,
            ind: 8,
            ty: 4,
            nm: "Shape Layer 16",
            parent: 9,
            td: 1,
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 50,
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: 0,
                ix: 9
              },
              rz: {
                a: 0,
                k: 0,
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  101.266,
                  101.266,
                  101.266
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "gf",
                    o: {
                      a: 0,
                      k: 100,
                      ix: 10
                    },
                    r: 1,
                    bm: 0,
                    g: {
                      p: 2,
                      k: {
                        a: 0,
                        k: [
                          0,
                          1,
                          1,
                          1,
                          1,
                          0.0784,
                          0.1686,
                          0.0588
                        ],
                        ix: 9
                      }
                    },
                    s: {
                      a: 0,
                      k: [
                        -512.975,
                        2.5
                      ],
                      ix: 5
                    },
                    e: {
                      a: 0,
                      k: [
                        549.589,
                        -14.873
                      ],
                      ix: 6
                    },
                    t: 1,
                    nm: "Gradient Fill 1",
                    mn: "ADBE Vector Graphic - G-Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 9,
            ty: 4,
            nm: "Shape Layer 15",
            parent: 1,
            tt: 3,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.667
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 34,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 56,
                    s: [
                      50
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 243,
                    s: [
                      50
                    ]
                  },
                  {
                    t: 277,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: -50,
                ix: 9
              },
              rz: {
                a: 0,
                k: 216,
                ix: 10
              },
              or: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.001
                    },
                    t: 15,
                    s: [
                      320,
                      0,
                      248
                    ],
                    to: [
                      248,
                      0,
                      0
                    ],
                    ti: [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    t: 118,
                    s: [
                      0,
                      0,
                      248
                    ]
                  }
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                        0,
                        0
                      ],
                      y: [
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333,
                        0.333,
                        0.333
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 15,
                    s: [
                      15.641,
                      15.641,
                      15.641
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833,
                        0.833,
                        0.833
                      ],
                      y: [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1,
                        1,
                        1
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 143,
                    s: [
                      79,
                      79,
                      79
                    ]
                  },
                  {
                    t: 298.7294921875,
                    s: [
                      0,
                      0,
                      0
                    ]
                  }
                ],
                ix: 6
              }
            },
            ao: 0,
            ef: [
              {
                ty: 20,
                nm: "Tint",
                np: 6,
                mn: "ADBE Tint",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "Map Black To",
                    mn: "ADBE Tint-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [
                        0.9294,
                        0.3137,
                        0.6196,
                        1
                      ],
                      ix: 1
                    }
                  },
                  {
                    ty: 2,
                    nm: "Map White To",
                    mn: "ADBE Tint-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: [
                        0.298,
                        0.3451,
                        0.3882,
                        1
                      ],
                      ix: 2
                    }
                  },
                  {
                    ty: 0,
                    nm: "Amount to Tint",
                    mn: "ADBE Tint-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: 100,
                      ix: 3
                    }
                  },
                  {
                    ty: 6,
                    nm: "",
                    mn: "ADBE Tint-0004",
                    ix: 4,
                    v: 0
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 2,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      1,
                      0.0784,
                      0.1686,
                      0.0588
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -394,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    365,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: "Gradient Fill 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 3
          },
          {
            ddd: 1,
            ind: 10,
            ty: 4,
            nm: "Shape Layer 14",
            parent: 11,
            td: 1,
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 50,
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: 0,
                ix: 9
              },
              rz: {
                a: 0,
                k: 0,
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  101.266,
                  101.266,
                  101.266
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "gf",
                    o: {
                      a: 0,
                      k: 100,
                      ix: 10
                    },
                    r: 1,
                    bm: 0,
                    g: {
                      p: 2,
                      k: {
                        a: 0,
                        k: [
                          0,
                          1,
                          1,
                          1,
                          1,
                          0.0784,
                          0.1686,
                          0.0588
                        ],
                        ix: 9
                      }
                    },
                    s: {
                      a: 0,
                      k: [
                        -512.975,
                        2.5
                      ],
                      ix: 5
                    },
                    e: {
                      a: 0,
                      k: [
                        549.589,
                        -14.873
                      ],
                      ix: 6
                    },
                    t: 1,
                    nm: "Gradient Fill 1",
                    mn: "ADBE Vector Graphic - G-Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 11,
            ty: 4,
            nm: "Shape Layer 13",
            parent: 1,
            tt: 3,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.667
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 27,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 49,
                    s: [
                      50
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 239,
                    s: [
                      50
                    ]
                  },
                  {
                    t: 273,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: -66,
                ix: 9
              },
              rz: {
                a: 0,
                k: 200,
                ix: 10
              },
              or: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.001
                    },
                    t: 10,
                    s: [
                      320,
                      0,
                      278
                    ],
                    to: [
                      278,
                      0,
                      0
                    ],
                    ti: [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    t: 112,
                    s: [
                      0,
                      0,
                      278
                    ]
                  }
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                        0,
                        0
                      ],
                      y: [
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333,
                        0.333,
                        0.333
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 7,
                    s: [
                      15.641,
                      15.641,
                      15.641
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833,
                        0.833,
                        0.833
                      ],
                      y: [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1,
                        1,
                        1
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 143,
                    s: [
                      79,
                      79,
                      79
                    ]
                  },
                  {
                    t: 289.7763671875,
                    s: [
                      0,
                      0,
                      0
                    ]
                  }
                ],
                ix: 6
              }
            },
            ao: 0,
            ef: [
              {
                ty: 20,
                nm: "Tint",
                np: 6,
                mn: "ADBE Tint",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "Map Black To",
                    mn: "ADBE Tint-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [
                        0.9294,
                        0.3137,
                        0.6196,
                        1
                      ],
                      ix: 1
                    }
                  },
                  {
                    ty: 2,
                    nm: "Map White To",
                    mn: "ADBE Tint-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: [
                        0.298,
                        0.3451,
                        0.3882,
                        1
                      ],
                      ix: 2
                    }
                  },
                  {
                    ty: 0,
                    nm: "Amount to Tint",
                    mn: "ADBE Tint-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: 100,
                      ix: 3
                    }
                  },
                  {
                    ty: 6,
                    nm: "",
                    mn: "ADBE Tint-0004",
                    ix: 4,
                    v: 0
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 2,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      1,
                      0.0784,
                      0.1686,
                      0.0588
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -394,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    365,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: "Gradient Fill 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 3
          },
          {
            ddd: 1,
            ind: 12,
            ty: 4,
            nm: "Shape Layer 12",
            parent: 13,
            td: 1,
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 50,
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: 0,
                ix: 9
              },
              rz: {
                a: 0,
                k: 0,
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  101.266,
                  101.266,
                  101.266
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "gf",
                    o: {
                      a: 0,
                      k: 100,
                      ix: 10
                    },
                    r: 1,
                    bm: 0,
                    g: {
                      p: 2,
                      k: {
                        a: 0,
                        k: [
                          0,
                          1,
                          1,
                          1,
                          1,
                          0.0784,
                          0.1686,
                          0.0588
                        ],
                        ix: 9
                      }
                    },
                    s: {
                      a: 0,
                      k: [
                        -512.975,
                        2.5
                      ],
                      ix: 5
                    },
                    e: {
                      a: 0,
                      k: [
                        549.589,
                        -14.873
                      ],
                      ix: 6
                    },
                    t: 1,
                    nm: "Gradient Fill 1",
                    mn: "ADBE Vector Graphic - G-Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 13,
            ty: 4,
            nm: "Shape Layer 11",
            parent: 1,
            tt: 3,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.667
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 21,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 43,
                    s: [
                      50
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 234,
                    s: [
                      50
                    ]
                  },
                  {
                    t: 268,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: -73,
                ix: 9
              },
              rz: {
                a: 0,
                k: 170,
                ix: 10
              },
              or: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.001
                    },
                    t: 6,
                    s: [
                      320,
                      0,
                      303
                    ],
                    to: [
                      303,
                      0,
                      0
                    ],
                    ti: [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    t: 107,
                    s: [
                      0,
                      0,
                      303
                    ]
                  }
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                        0,
                        0
                      ],
                      y: [
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333,
                        0.333,
                        0.333
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 0,
                    s: [
                      15.641,
                      15.641,
                      15.641
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833,
                        0.833,
                        0.833
                      ],
                      y: [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1,
                        1,
                        1
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 143,
                    s: [
                      79,
                      79,
                      79
                    ]
                  },
                  {
                    t: 280.8203125,
                    s: [
                      0,
                      0,
                      0
                    ]
                  }
                ],
                ix: 6
              }
            },
            ao: 0,
            ef: [
              {
                ty: 20,
                nm: "Tint",
                np: 6,
                mn: "ADBE Tint",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "Map Black To",
                    mn: "ADBE Tint-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [
                        0.9294,
                        0.3137,
                        0.6196,
                        1
                      ],
                      ix: 1
                    }
                  },
                  {
                    ty: 2,
                    nm: "Map White To",
                    mn: "ADBE Tint-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: [
                        0.298,
                        0.3451,
                        0.3882,
                        1
                      ],
                      ix: 2
                    }
                  },
                  {
                    ty: 0,
                    nm: "Amount to Tint",
                    mn: "ADBE Tint-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: 100,
                      ix: 3
                    }
                  },
                  {
                    ty: 6,
                    nm: "",
                    mn: "ADBE Tint-0004",
                    ix: 4,
                    v: 0
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 2,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      1,
                      0.0784,
                      0.1686,
                      0.0588
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -394,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    365,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: "Gradient Fill 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 3
          },
          {
            ddd: 1,
            ind: 14,
            ty: 4,
            nm: "Shape Layer 10",
            parent: 15,
            td: 1,
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 50,
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: 0,
                ix: 9
              },
              rz: {
                a: 0,
                k: 0,
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  101.266,
                  101.266,
                  101.266
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "gf",
                    o: {
                      a: 0,
                      k: 100,
                      ix: 10
                    },
                    r: 1,
                    bm: 0,
                    g: {
                      p: 2,
                      k: {
                        a: 0,
                        k: [
                          0,
                          1,
                          1,
                          1,
                          1,
                          0.0784,
                          0.1686,
                          0.0588
                        ],
                        ix: 9
                      }
                    },
                    s: {
                      a: 0,
                      k: [
                        -512.975,
                        2.5
                      ],
                      ix: 5
                    },
                    e: {
                      a: 0,
                      k: [
                        549.589,
                        -14.873
                      ],
                      ix: 6
                    },
                    t: 1,
                    nm: "Gradient Fill 1",
                    mn: "ADBE Vector Graphic - G-Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 15,
            ty: 4,
            nm: "Shape Layer 9",
            parent: 1,
            tt: 3,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.667
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 16,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 38,
                    s: [
                      50
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 230,
                    s: [
                      50
                    ]
                  },
                  {
                    t: 264,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: -74,
                ix: 9
              },
              rz: {
                a: 0,
                k: 140,
                ix: 10
              },
              or: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.001
                    },
                    t: 2,
                    s: [
                      320,
                      0,
                      327
                    ],
                    to: [
                      327,
                      0,
                      0
                    ],
                    ti: [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    t: 101,
                    s: [
                      0,
                      0,
                      327
                    ]
                  }
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                        0,
                        0
                      ],
                      y: [
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333,
                        0.333,
                        0.333
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: -5,
                    s: [
                      27,
                      27,
                      27
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833,
                        0.833,
                        0.833
                      ],
                      y: [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1,
                        1,
                        1
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 143,
                    s: [
                      79,
                      79,
                      79
                    ]
                  },
                  {
                    t: 271.8671875,
                    s: [
                      0,
                      0,
                      0
                    ]
                  }
                ],
                ix: 6
              }
            },
            ao: 0,
            ef: [
              {
                ty: 20,
                nm: "Tint",
                np: 6,
                mn: "ADBE Tint",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "Map Black To",
                    mn: "ADBE Tint-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [
                        0.9294,
                        0.3137,
                        0.6196,
                        1
                      ],
                      ix: 1
                    }
                  },
                  {
                    ty: 2,
                    nm: "Map White To",
                    mn: "ADBE Tint-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: [
                        0.298,
                        0.3451,
                        0.3882,
                        1
                      ],
                      ix: 2
                    }
                  },
                  {
                    ty: 0,
                    nm: "Amount to Tint",
                    mn: "ADBE Tint-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: 100,
                      ix: 3
                    }
                  },
                  {
                    ty: 6,
                    nm: "",
                    mn: "ADBE Tint-0004",
                    ix: 4,
                    v: 0
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 2,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      1,
                      0.0784,
                      0.1686,
                      0.0588
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -394,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    365,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: "Gradient Fill 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 3
          },
          {
            ddd: 1,
            ind: 16,
            ty: 4,
            nm: "Shape Layer 8",
            parent: 17,
            td: 1,
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 50,
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: 0,
                ix: 9
              },
              rz: {
                a: 0,
                k: 0,
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  101.266,
                  101.266,
                  101.266
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "gf",
                    o: {
                      a: 0,
                      k: 100,
                      ix: 10
                    },
                    r: 1,
                    bm: 0,
                    g: {
                      p: 2,
                      k: {
                        a: 0,
                        k: [
                          0,
                          1,
                          1,
                          1,
                          1,
                          0.0784,
                          0.1686,
                          0.0588
                        ],
                        ix: 9
                      }
                    },
                    s: {
                      a: 0,
                      k: [
                        -512.975,
                        2.5
                      ],
                      ix: 5
                    },
                    e: {
                      a: 0,
                      k: [
                        549.589,
                        -14.873
                      ],
                      ix: 6
                    },
                    t: 1,
                    nm: "Gradient Fill 1",
                    mn: "ADBE Vector Graphic - G-Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 17,
            ty: 4,
            nm: "Shape Layer 7",
            parent: 1,
            tt: 3,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.667
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 8,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 30,
                    s: [
                      50
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 226,
                    s: [
                      50
                    ]
                  },
                  {
                    t: 260,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: -60,
                ix: 9
              },
              rz: {
                a: 0,
                k: 125,
                ix: 10
              },
              or: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.001
                    },
                    t: 0,
                    s: [
                      320,
                      0,
                      347
                    ],
                    to: [
                      347,
                      0,
                      0
                    ],
                    ti: [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    t: 97,
                    s: [
                      0,
                      0,
                      347
                    ]
                  }
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                        0,
                        0
                      ],
                      y: [
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333,
                        0.333,
                        0.333
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: -12,
                    s: [
                      27,
                      27,
                      27
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833,
                        0.833,
                        0.833
                      ],
                      y: [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1,
                        1,
                        1
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 143,
                    s: [
                      79,
                      79,
                      79
                    ]
                  },
                  {
                    t: 262.9091796875,
                    s: [
                      0,
                      0,
                      0
                    ]
                  }
                ],
                ix: 6
              }
            },
            ao: 0,
            ef: [
              {
                ty: 20,
                nm: "Tint",
                np: 6,
                mn: "ADBE Tint",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "Map Black To",
                    mn: "ADBE Tint-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [
                        0.9294,
                        0.3137,
                        0.6196,
                        1
                      ],
                      ix: 1
                    }
                  },
                  {
                    ty: 2,
                    nm: "Map White To",
                    mn: "ADBE Tint-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: [
                        0.298,
                        0.3451,
                        0.3882,
                        1
                      ],
                      ix: 2
                    }
                  },
                  {
                    ty: 0,
                    nm: "Amount to Tint",
                    mn: "ADBE Tint-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: 100,
                      ix: 3
                    }
                  },
                  {
                    ty: 6,
                    nm: "",
                    mn: "ADBE Tint-0004",
                    ix: 4,
                    v: 0
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 2,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      1,
                      0.0784,
                      0.1686,
                      0.0588
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -394,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    365,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: "Gradient Fill 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 3
          },
          {
            ddd: 1,
            ind: 18,
            ty: 4,
            nm: "Shape Layer 24",
            parent: 19,
            td: 1,
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 50,
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: 0,
                ix: 9
              },
              rz: {
                a: 0,
                k: 0,
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  101.266,
                  101.266,
                  101.266
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "gf",
                    o: {
                      a: 0,
                      k: 100,
                      ix: 10
                    },
                    r: 1,
                    bm: 0,
                    g: {
                      p: 2,
                      k: {
                        a: 0,
                        k: [
                          0,
                          1,
                          1,
                          1,
                          1,
                          0.0784,
                          0.1686,
                          0.0588
                        ],
                        ix: 9
                      }
                    },
                    s: {
                      a: 0,
                      k: [
                        -512.975,
                        2.5
                      ],
                      ix: 5
                    },
                    e: {
                      a: 0,
                      k: [
                        549.589,
                        -14.873
                      ],
                      ix: 6
                    },
                    t: 1,
                    nm: "Gradient Fill 1",
                    mn: "ADBE Vector Graphic - G-Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 0
          },
          {
            ddd: 1,
            ind: 19,
            ty: 4,
            nm: "Shape Layer 23",
            parent: 1,
            tt: 3,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.667
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 6,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 28,
                    s: [
                      50
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 221,
                    s: [
                      50
                    ]
                  },
                  {
                    t: 255,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: -48,
                ix: 9
              },
              rz: {
                a: 0,
                k: 90,
                ix: 10
              },
              or: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.002
                    },
                    t: 0,
                    s: [
                      320,
                      0,
                      8
                    ],
                    to: [
                      8,
                      0,
                      0
                    ],
                    ti: [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    t: 93,
                    s: [
                      0,
                      0,
                      8
                    ]
                  }
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                        0,
                        0
                      ],
                      y: [
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333,
                        0.333,
                        0.333
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: -17,
                    s: [
                      27,
                      27,
                      27
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833,
                        0.833,
                        0.833
                      ],
                      y: [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1,
                        1,
                        1
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 143,
                    s: [
                      79,
                      79,
                      79
                    ]
                  },
                  {
                    t: 253.955078125,
                    s: [
                      0,
                      0,
                      0
                    ]
                  }
                ],
                ix: 6
              }
            },
            ao: 0,
            ef: [
              {
                ty: 20,
                nm: "Tint",
                np: 6,
                mn: "ADBE Tint",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "Map Black To",
                    mn: "ADBE Tint-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [
                        0.9294,
                        0.3137,
                        0.6196,
                        1
                      ],
                      ix: 1
                    }
                  },
                  {
                    ty: 2,
                    nm: "Map White To",
                    mn: "ADBE Tint-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: [
                        0.298,
                        0.3451,
                        0.3882,
                        1
                      ],
                      ix: 2
                    }
                  },
                  {
                    ty: 0,
                    nm: "Amount to Tint",
                    mn: "ADBE Tint-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: 100,
                      ix: 3
                    }
                  },
                  {
                    ty: 6,
                    nm: "",
                    mn: "ADBE Tint-0004",
                    ix: 4,
                    v: 0
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 2,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      1,
                      0.0784,
                      0.1686,
                      0.0588
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -394,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    365,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: "Gradient Fill 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 3
          },
          {
            ddd: 1,
            ind: 20,
            ty: 4,
            nm: "Shape Layer 26",
            parent: 21,
            td: 1,
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 50,
                ix: 11
              },
              rx: {
                a: 0,
                k: 0,
                ix: 8
              },
              ry: {
                a: 0,
                k: 0,
                ix: 9
              },
              rz: {
                a: 0,
                k: 0,
                ix: 10
              },
              or: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 0,
                k: [
                  101.266,
                  101.266,
                  101.266
                ],
                ix: 6
              }
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "gf",
                    o: {
                      a: 0,
                      k: 100,
                      ix: 10
                    },
                    r: 1,
                    bm: 0,
                    g: {
                      p: 2,
                      k: {
                        a: 0,
                        k: [
                          0,
                          1,
                          1,
                          1,
                          1,
                          0.0784,
                          0.1686,
                          0.0588
                        ],
                        ix: 9
                      }
                    },
                    s: {
                      a: 0,
                      k: [
                        -512.975,
                        2.5
                      ],
                      ix: 5
                    },
                    e: {
                      a: 0,
                      k: [
                        549.589,
                        -14.873
                      ],
                      ix: 6
                    },
                    t: 1,
                    nm: "Gradient Fill 1",
                    mn: "ADBE Vector Graphic - G-Fill",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              }
            ],
            ip: -3,
            op: 301,
            st: 1,
            bm: 0
          },
          {
            ddd: 1,
            ind: 21,
            ty: 4,
            nm: "Shape Layer 25",
            parent: 1,
            tt: 3,
            sr: 1,
            ks: {
              o: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0.667
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 45,
                    s: [
                      0
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 120,
                    s: [
                      50
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833
                      ],
                      y: [
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.167
                      ],
                      y: [
                        0
                      ]
                    },
                    t: 216,
                    s: [
                      50
                    ]
                  },
                  {
                    t: 250,
                    s: [
                      0
                    ]
                  }
                ],
                ix: 11
              },
              rx: {
                a: 0,
                k: 14,
                ix: 8
              },
              ry: {
                a: 0,
                k: -19,
                ix: 9
              },
              rz: {
                a: 0,
                k: 65,
                ix: 10
              },
              or: {
                a: 1,
                k: [
                  {
                    i: {
                      x: 0,
                      y: 1
                    },
                    o: {
                      x: 0.167,
                      y: 0.002
                    },
                    t: 0,
                    s: [
                      320,
                      0,
                      8
                    ],
                    to: [
                      8,
                      0,
                      0
                    ],
                    ti: [
                      0,
                      0,
                      0
                    ]
                  },
                  {
                    t: 89,
                    s: [
                      0,
                      0,
                      8
                    ]
                  }
                ],
                ix: 7
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 2
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                  0
                ],
                ix: 1
              },
              s: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [
                        0,
                        0,
                        0
                      ],
                      y: [
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      x: [
                        0.333,
                        0.333,
                        0.333
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: -23,
                    s: [
                      27,
                      27,
                      27
                    ]
                  },
                  {
                    i: {
                      x: [
                        0.833,
                        0.833,
                        0.833
                      ],
                      y: [
                        0.833,
                        0.833,
                        0.833
                      ]
                    },
                    o: {
                      x: [
                        1,
                        1,
                        1
                      ],
                      y: [
                        0,
                        0,
                        0
                      ]
                    },
                    t: 143,
                    s: [
                      79,
                      79,
                      79
                    ]
                  },
                  {
                    t: 245,
                    s: [
                      0,
                      0,
                      0
                    ]
                  }
                ],
                ix: 6
              }
            },
            ao: 0,
            ef: [
              {
                ty: 20,
                nm: "Tint",
                np: 6,
                mn: "ADBE Tint",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "Map Black To",
                    mn: "ADBE Tint-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [
                        0.9294,
                        0.3137,
                        0.6196,
                        1
                      ],
                      ix: 1
                    }
                  },
                  {
                    ty: 2,
                    nm: "Map White To",
                    mn: "ADBE Tint-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: [
                        0.298,
                        0.3451,
                        0.3882,
                        1
                      ],
                      ix: 2
                    }
                  },
                  {
                    ty: 0,
                    nm: "Amount to Tint",
                    mn: "ADBE Tint-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: 100,
                      ix: 3
                    }
                  },
                  {
                    ty: 6,
                    nm: "",
                    mn: "ADBE Tint-0004",
                    ix: 4,
                    v: 0
                  }
                ]
              }
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ],
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ]
                            ],
                            o: [
                              [
                                276.142,
                                0
                              ],
                              [
                                0,
                                276.142
                              ],
                              [
                                -276.142,
                                0
                              ],
                              [
                                0,
                                -276.142
                              ]
                            ],
                            v: [
                              [
                                0,
                                -500
                              ],
                              [
                                500,
                                0
                              ],
                              [
                                0,
                                500
                              ],
                              [
                                -500,
                                0
                              ]
                            ],
                            c: true
                          },
                          ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                      },
                      {
                        ty: "tr",
                        p: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 2
                        },
                        a: {
                          a: 0,
                          k: [
                            0,
                            0
                          ],
                          ix: 1
                        },
                        s: {
                          a: 0,
                          k: [
                            100,
                            100
                          ],
                          ix: 3
                        },
                        r: {
                          a: 0,
                          k: 0,
                          ix: 6
                        },
                        o: {
                          a: 0,
                          k: 100,
                          ix: 7
                        },
                        sk: {
                          a: 0,
                          k: 0,
                          ix: 4
                        },
                        sa: {
                          a: 0,
                          k: 0,
                          ix: 5
                        },
                        nm: "Transform"
                      }
                    ],
                    nm: "one",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 2
                    },
                    a: {
                      a: 0,
                      k: [
                        0,
                        0
                      ],
                      ix: 1
                    },
                    s: {
                      a: 0,
                      k: [
                        100,
                        100
                      ],
                      ix: 3
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5
                    },
                    nm: "Transform"
                  }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 2,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      1,
                      0.0784,
                      0.1686,
                      0.0588
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -394,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    365,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: "Gradient Fill 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: false
              }
            ],
            ip: 0,
            op: 300,
            st: 0,
            bm: 3
          }
        ],
        markers: []
      }
    
      export default orbGradientAnimation;